import { defineQueryKeyCreator } from "@app/common/utils/queryUtils";

const define = defineQueryKeyCreator("checkout");

export const QueryKeys = {
    CheckoutBookingValidatableDependencyData: define("checkout-booking-validatable-dependency-data"),
    PCIBookingAccessToken: define("pci-booking-access-token"),
    RDPIframeUrl: define("rdp-iframe-url"),
} as const;
